"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKCheckbox = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var GKCheckbox = /** @class */ (function (_super) {
    __extends(GKCheckbox, _super);
    function GKCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setIndeterminateStatus = function () {
            if (_this.input) {
                _this.input.indeterminate = _this.props.indeterminate || false;
            }
        };
        return _this;
    }
    GKCheckbox.prototype.componentDidMount = function () {
        this.setIndeterminateStatus();
    };
    GKCheckbox.prototype.componentDidUpdate = function () {
        this.setIndeterminateStatus();
    };
    GKCheckbox.prototype.render = function () {
        var _this = this;
        var _a;
        var inputId = this.uniqueId + "-input";
        var _b = this.props, checked = _b.checked, className = _b.className, disabled = _b.disabled, 
        // Intentionally destructured from otherProps
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        id = _b.id, 
        // Intentionally destructured from otherProps
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        indeterminate = _b.indeterminate, inline = _b.inline, label = _b.label, name = _b.name, onBlur = _b.onBlur, onChange = _b.onChange, readOnly = _b.readOnly, required = _b.required, toggle = _b.toggle, otherProps = __rest(_b, ["checked", "className", "disabled", "id", "indeterminate", "inline", "label", "name", "onBlur", "onChange", "readOnly", "required", "toggle"]);
        // TECHDEBT (AW 9-21-18): Update assets to use gk-checkbox class - better yet, keep styles with their components
        var classes = ["GKCheckbox", "custom-control"];
        classes.push(toggle ? "custom-switch" : "custom-checkbox");
        inline && classes.push("custom-control-inline");
        required && classes.push("required");
        className && classes.push.apply(classes, className === null || className === void 0 ? void 0 : className.split(" "));
        var qaProp = (_a = this.props["data-qa"]) !== null && _a !== void 0 ? _a : "gk-checkbox";
        return (React.createElement("div", __assign({}, (0, common_1.mapDefaultProps)(otherProps, {
            _gkComponentName: "gk-checkbox",
            className: classes.join(" "),
            id: this.uniqueId,
        })),
            React.createElement("input", { type: "checkbox", className: "custom-control-input", checked: checked, "data-qa": qaProp + "--input", disabled: disabled, id: inputId, name: name, onBlur: onBlur, onChange: onChange, readOnly: readOnly, ref: function (ref) { return (_this.input = ref); } }),
            React.createElement("label", { "data-qa": qaProp + "--label", htmlFor: inputId, className: "custom-control-label" },
                required && (React.createElement("span", { className: "required-indicator", "data-qa": qaProp + "--required-indicator", "aria-hidden": true })),
                label)));
    };
    return GKCheckbox;
}(common_1.GKPureComponent));
exports.GKCheckbox = GKCheckbox;
